import { Box, Stack, Tab, Tabs } from '@mui/material'
import { NavLink, useLocation } from 'react-router-dom'
import { routesProfile } from '../../../consts'
import { TabsStyle } from '../../../components/Events/EventsTabs/style'
import type { RecommendationsSummaryResponse } from '../../../api/types/recommendations'
import { COLORS } from '../../../styles/variables'

type RecommendationsTabsProps = {
  counts?: RecommendationsSummaryResponse['tabs']
}

const getTabLabel = (label: string, count = 0) => (
  <Stack direction="row" component="span" alignItems="center" gap={0.75}>
    <Box component="span">{label}</Box>
    <Box component="span" sx={{ color: COLORS.CERULEAN, fontWeight: 700 }}>{count}</Box>
  </Stack>
)

export const RecommendationsTabs = ({ counts }: RecommendationsTabsProps) => {
  const { pathname } = useLocation()

  const currentTab = pathname.endsWith('/projects')
    ? 1
    : pathname.endsWith('/resources')
      ? 2
      : pathname.endsWith('/teams')
        ? 3
        : 0

  return (
    <Stack direction="column" gap={{ xs: 1.5, sm: 2 }} mb={2} sx={{ minWidth: 0 }}>
      <Tabs value={currentTab} variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile sx={TabsStyle}>
        <Tab label={getTabLabel('Мне', counts?.for_me)} component={NavLink} to={`/${routesProfile.RECOMMENDATIONS.path}`} end />
        <Tab label={getTabLabel('Моим проектам', counts?.for_my_projects)} component={NavLink} to={`/${routesProfile.RECOMMENDATIONS.path}/projects`} />
        <Tab label={getTabLabel('Ресурсы', counts?.for_resources)} component={NavLink} to={`/${routesProfile.RECOMMENDATIONS.path}/resources`} />
        <Tab label={getTabLabel('Моим командам', counts?.for_my_teams)} component={NavLink} to={`/${routesProfile.RECOMMENDATIONS.path}/teams`} />
      </Tabs>
    </Stack>
  )
}
